module.exports = __webpack_public_path__ + "img/flat_transparent_logo.55c91f8e.png";